import React, { useState } from "react";

import styles from "./styles/ChatThreads.module.scss";

import { CardTitle, Input, SubTitle } from "../../Components/CustomComponents";

import { CiSearch } from "react-icons/ci";
import BorderedCard from "../../Components/Cards/BorderedCard";
import { useSocket } from "../../Context/SocketContext";
import { useChatContext } from "./context/ChatContext";
import { Spinner } from "react-bootstrap";
import _ from "lodash";
import { resetChatCount } from "../../Data/services/localStorageService";
import { removeCount, setCount } from "../../Data/features/chatSlice";
import { useDispatch } from "react-redux";

export default function ChatThreads({ setUser }) {
  const socket = useSocket();
  const dispatch = useDispatch();

  const {
    chatRoom,
    setChatRoom,
    chatThreads,
    resetMessageCount,
    search,
    setSearch,
  } = useChatContext();

  const handleThreadClick = (data) => {
    console.log(data);
    if (data?.chat_room_id === chatRoom?.id) return;
    setChatRoom({
      id: data.chat_room_id,
      room_name: data.room_name || "",
      image_url: data.image_url,
    });
    resetMessageCount(data.chat_room_id);
    // resetChatCount(data.unread_message_count);

    console.log(data.unread_message_count);

    dispatch(removeCount(data.unread_message_count));
  };

  return (
    <div className={styles.ChatThreads}>
      <div className={`${styles.titleContainer} gap-3`}>
        <SubTitle text="Messages" />

        <Input
          type="search"
          className={styles.searchInput}
          placeholder="Search name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />
      </div>
      <div className={styles.threads}>
        {chatThreads?.isLoading ? (
          <span className={styles.noThreads}>
            <Spinner variant="success" />
          </span>
        ) : _.isEmpty(chatThreads?.data) ? (
          <p className={styles.noThreads}> Empty Inbox </p>
        ) : (
          (chatThreads.data ?? []).map((item, index) => {
            // console.log(item);
            return (
              <div onClick={() => handleThreadClick(item)} key={item.user_id}>
                <BorderedCard classes="my-2 overflow-visible">
                  <div className={styles.thread}>
                    <img
                      className={styles.userImage}
                      src={item.image_url || "/images/no_image_available.png"}
                      alt="User Profile"
                    />
                    <div className={styles.userInfo}>
                      <div className={styles.nameContainer}>
                        <CardTitle text={item.room_name} classes="fs-6 lc-1" />
                        {(!!item.unread_message_count || false) === true ? (
                          <span className={styles.indicator}></span>
                        ) : (
                          ""
                        )}
                      </div>
                      <p className={`${styles.message} mt-1 pe-1 lc-1`}>
                        {item?.message?.message}
                      </p>
                    </div>
                  </div>
                </BorderedCard>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
